<template>
    <div class="main-con">
        <div class="actions-con">
            <PrimeButton @click="emit('closeDialog'), store.uploads = []" label="Cancel" variant="secondary" class="p-btn-root_secondary" />
            <PrimeButton @click="handleUploadFile" label="Attach files" :disabled="store.uploads.length === 0"
                :loading="loader" />
        </div>
    </div>
</template>
<script setup lang="ts">
import { useContactsTempStore } from '~/stores/person/contacts-temp';
const store = useContactsTempStore();
const emit = defineEmits(['closeDialog']);
const { showSuccess, showError, showWarning } = useGlobalToast();
const loader = ref(false);

const handleUploadFile = () => {
    //remove simulation
    // loader.value = true;
    // setTimeout(() => {
    //     showSuccess('Success', 'Files uploaded successfully');
    //     store.uploads = [];
    //     loader.value = false;
    //     emit('closeDialog');
    // }, 3000);
};
</script>
<style lang="scss" scoped>
.main-con {
    @apply flex flex-col pt-8 items-start self-stretch;

    .actions-con {
        @apply flex justify-end items-start gap-3 px-6 pb-6 self-stretch;
    }
}
</style>
